import * as React from "react";
import { pure } from "recompose";
import LayoutGrid from "@tunnel-components/layouts/layout/index";
import BreadCrumb from "@tunnel-components/@sharded/widgets/breadcrumb/component";

import * as Paths from "@tunnel-enums/index";
import * as cx from "classnames";
import Line from "@tunnel-components/@sharded/@widgets/chart/component";
import * as Lodash from "lodash";
import * as i18next from "i18next"; // traduction

/**
 * @function Component : Composant fonctionnel
 * @description : fonction simple qui prend en argument un objet props
 * et rend du contenu sous forme d'élement  JSX
 * @param { any } props
 * @returns { JSX.Element }
 * @implements { ComponentInterface }
 * @type { React.FunctionComponent }
 * @infos "https://reactjs.org"
 */
const Component: React.FunctionComponent<any> = (props: any): JSX.Element => {
  /**
   * @affectation
   * @description :
   * Affectation par décomposition des élements de l'objet (props)
   * les élements existent ou sont créés dans ( ou par) la @class container
   * fonctions , méthodes, variables , objets, tableaux ...., sont les éléments
   * susceptibles de subir une affectation par décomposition
   * exemple : const { elements } = objet ;
   * @infos "https://developer.mozilla.org"
   */
  // desturation
  const {
    loading,
    ongletSelect,
    onglet,
    onOngletSelect,
    paramIdentifiant,
    dataYForTrueAlerte,
    dataYForFalseAlerte,
    dataYForAllAlerte,
    label,
    onPeriodOpen,
    onSelectToggle,
  } = props;

  /**
   * @description : Liste des caméras
   * @const
   * @type { any }
   * @name dataAll
   */

  const dataAll: any = (canvas: any): any => {
    const ctx = canvas.getContext("2d");
    const gradient = ctx.createLinearGradient(0, 0, 0, 1000);
    gradient.addColorStop(0, "rgba(242, 242, 242,.8)");
    gradient.addColorStop(1, "rgba(242, 242, 242,0)");

    const gradientTrue = ctx.createLinearGradient(0, 0, 0, 1000);
    gradientTrue.addColorStop(0, "rgba(0, 236, 188,.8)");
    gradientTrue.addColorStop(1, "rgba(0, 236, 188,0)");

    const gradientFalse = ctx.createLinearGradient(0, 0, 0, 1000);
    gradientFalse.addColorStop(0, "rgba(51, 102, 255,8)");
    gradientFalse.addColorStop(1, "rgba(51, 102, 255,0)");
    return {
      labels: label,
      datasets: [
        {
          label: i18next.t("nombre totale d'alarmes"),
          fill: true,
          lineTension: 0.3,
          backgroundColor: gradient,
          pointBorderWidth: 0.5,
          pointRadius: 0,
          borderWidth: 0,
          data: dataYForAllAlerte,
        },
        {
          label: i18next.t("nombre faux positifs"),
          fill: true,
          lineTension: 0.3,
          backgroundColor: gradientFalse,
          pointBorderWidth: 0.5,
          borderWidth: 0,
          pointRadius: 0,
          data: dataYForFalseAlerte,
        },
        {
          label: i18next.t("nombre d'incidents averes"),
          fill: true,
          lineTension: 0.3,
          backgroundColor: gradientTrue,
          pointBorderWidth: 0.5,
          pointRadius: 0,
          borderWidth: 0,
          data: dataYForTrueAlerte,
        },
      ],
    };
  };
  /**
   * @description : Liste des caméras
   * @const
   * @name dataFalse
   */
  const dataFalse = (canvas: any) => {
    const ctx = canvas.getContext("2d");

    const gradient = ctx.createLinearGradient(0, 0, 0, 1000);
    gradient.addColorStop(0, "rgba(51, 102, 255,1)");
    gradient.addColorStop(1, "rgba(51, 102, 255,0)");
    return {
      labels: label,
      datasets: [
        {
          label: i18next.t("nombre faux positifs"),
          fill: true,
          pointRadius: 0,
          lineTension: 0.3,
          backgroundColor: gradient,
          borderColor: gradient,
          pointBorderWidth: 0.5,
          borderWidth: 0,
          data: dataYForFalseAlerte,
        },
      ],
    };
  };

  /**
   * @description : Liste des caméras
   * @const
   * @name dataTrue
   */
  const dataTrue = (canvas: any) => {
    const ctx = canvas.getContext("2d");

    const gradient = ctx.createLinearGradient(0, 0, 0, 1000);
    gradient.addColorStop(0, "rgba(0, 236, 188,1)");
    gradient.addColorStop(1, "rgba(0, 236, 188,0)");

    return {
      labels: label,
      datasets: [
        {
          label: i18next.t("nombre d'incidents averes"),
          fill: true,
          lineTension: 0.3,
          pointRadius: 0,
          backgroundColor: gradient,
          borderColor: gradient,
          pointBorderWidth: 0.5,
          borderWidth: 0,
          data: dataYForTrueAlerte,
        },
      ],
    };
  };

  /**
   * @expression return()
   * @description :
   * Cette expression transforme un élément JSX en élément HTML
   * @infos "https://reactjs.org"
   */
  return (
    <LayoutGrid loading={loading} error={props.errorserver}>
      {true && (
        <section className="tunnel-site animated fadeIn">
          {true && (
            <BreadCrumb
              iconSupervision={true}
              links1={`${Paths.PathsNamesEnums.CAMERASETTINGID}${paramIdentifiant}`}
              title={i18next.t("supervision")}
              breadText1={i18next.t("camera")}
              breadText2={`${i18next.t("statistique")} # ${paramIdentifiant}`}
            />
          )}

          <div className="contentAllSiteWithoutOnglet ">
            <section className="columnsWithoutOnglet">
              <section className="content-wrapper">
                <section className="incident-items ">
                  <div className="statistic with-1-columns">
                    <li className="cart-box-incidents">
                      <div className="cart-incident">
                        <div className="statsHeader">
                          <span className="statsonglet">
                            {onglet.map((elem: any, index: number) => (
                              <span className="statOngletInsider" key={index}>
                                <span
                                  className={cx({
                                    "selectStatOnglet animated fadeIn":
                                      ongletSelect[index],
                                  })}
                                  onClick={onOngletSelect(index)}
                                >
                                  {" "}
                                  <p>
                                    <span
                                      className={cx(`icon-stats${index}`)}
                                    />{" "}
                                    {elem}
                                  </p>{" "}
                                </span>
                              </span>
                            ))}
                          </span>
                        </div>
                        {/** le contenu des statistiques */}
                        {ongletSelect[0] &&
                          !Lodash.isUndefined(label) &&
                          !Lodash.isUndefined(dataYForAllAlerte) &&
                          !Lodash.isUndefined(dataYForTrueAlerte) &&
                          !Lodash.isUndefined(dataYForTrueAlerte) && (
                            <Line
                              Data={dataAll}
                              periodText={props.periodText}
                              onPeriodOpen={onPeriodOpen}
                              periodOpen={props.periodOpen}
                              periodArray={props.periodArray}
                              onSelectToggle={onSelectToggle}
                            />
                          )}
                        {ongletSelect[1] &&
                          !Lodash.isUndefined(label) &&
                          !Lodash.isUndefined(dataYForFalseAlerte) && (
                            <Line
                              Data={dataFalse}
                              periodText={props.periodText}
                              onPeriodOpen={onPeriodOpen}
                              periodOpen={props.periodOpen}
                              periodArray={props.periodArray}
                              onSelectToggle={onSelectToggle}
                            />
                          )}
                        {ongletSelect[2] &&
                          !Lodash.isUndefined(label) &&
                          !Lodash.isUndefined(dataYForTrueAlerte) && (
                            <Line
                              Data={dataTrue}
                              periodText={props.periodText}
                              onPeriodOpen={onPeriodOpen}
                              periodOpen={props.periodOpen}
                              periodArray={props.periodArray}
                              onSelectToggle={onSelectToggle}
                            />
                          )}
                      </div>
                    </li>
                  </div>
                </section>
              </section>
            </section>
          </div>
        </section>
      )}
    </LayoutGrid>
  );
};

/** Valeurs par défaut des props */
Component.defaultProps = {};
/**
 * @interface ComponentInterface
 * @description :
 * Cette interface définit le model du props
 */

/** @export HOC pure */
export default pure(Component);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@pages/supervision/camera/statistics/component.tsx